// extracted by mini-css-extract-plugin
export default {"row":"ImageTopNews_row__U5Nkj","col":"ImageTopNews_col__NEcdz"};